import React from "react";
import { Link } from "react-router-dom";

import { formatInvoiceNumber } from "../../helpers/format";

interface Props {
  invoiceNumber?: string;
  prefix?: string;
  className?: string;
}

const InvoiceLink = ({ invoiceNumber, prefix, className }: Props) => {
  if (!invoiceNumber) {
    return null;
  }
  const formattedInvoiceNumber = formatInvoiceNumber(invoiceNumber, prefix);

  return (
    <Link className={className} to={`/invoices/${invoiceNumber}`}>
      {formattedInvoiceNumber}
    </Link>
  );
};

export default InvoiceLink;
